import React, { FC } from "react";
import { faArrowRight } from "@fortawesome/pro-regular-svg-icons/faArrowRight";
import { FontAwesomeIcon, FontAwesomeIconProps } from "@fortawesome/react-fontawesome";

export const ArrowRight: FC<Omit<FontAwesomeIconProps, "icon">> = (props) => (
  <FontAwesomeIcon icon={faArrowRight} {...props} />
);
